import React from 'react';

interface WiziQuizHeaderProps {
  candidateName: string;
  examName: string;
  subjectName: string;
  timeRemaining: number; // in seconds
  onLanguageChange?: (language: string) => void;
}

const WiziQuizHeader: React.FC<WiziQuizHeaderProps> = ({
  candidateName,
  examName,
  subjectName,
  timeRemaining,
  onLanguageChange,
}) => {
  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const getTimeColor = (): string => {
    if (timeRemaining <= 300) return 'text-danger'; // Red for last 5 minutes
    if (timeRemaining <= 600) return 'text-warning'; // Yellow for last 10 minutes
    return 'text-primary';
  };

  return (
    <div className="bg-white border-bottom shadow-sm py-2 px-3">
      <div className="row align-items-center">
        {/* Left: User Info */}
        <div className="col-md-3 col-6">
          <div className="d-flex align-items-center">
            <i className="fas fa-user-circle fa-2x text-primary me-2"></i>
            <div>
              <div className="small text-muted">Candidate Name</div>
              <div className="fw-bold text-primary">{candidateName}</div>
            </div>
          </div>
        </div>

        {/* Center: Exam & Subject Info */}
        <div className="col-md-6 col-12 mt-2 mt-md-0">
          <div className="text-center">
            <div className="small text-muted">Exam Name</div>
            <div className="fw-bold">{examName}</div>
            {/* <div className="small text-muted mt-1">Subject Name</div>
            <div className="fw-semibold text-warning">{subjectName}</div> */}
          </div>
        </div>

        {/* Right: Timer & Language */}
        <div className="col-md-3 col-6 mt-2 mt-md-0">
          <div className="d-flex justify-content-end align-items-center gap-3">
            {/* Timer */}
            <div className="text-end">
              <div className="small text-muted">Remaining Time</div>
              <div className={`fw-bold fs-5 ${getTimeColor()}`}>
                {formatTime(timeRemaining)}
              </div>
            </div>

            {/* Language Selector */}
            {/* <select
              className="form-select form-select-sm"
              style={{ width: 'auto' }}
              onChange={(e) => onLanguageChange?.(e.target.value)}
              defaultValue="english"
            >
              <option value="english">English</option>
              <option value="hindi">हिंदी</option>
            </select> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WiziQuizHeader;
